module.exports = __webpack_public_path__ + "static/media/Pedidos1.9cca06e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancPedidos/Pedidos1.png
// module id = 1780
// module chunks = 0